import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

/**
 * returns DLS TextArea component
 * @param {*} props
 */
const P = (props) => {
  const {
    cssProperties,
    fieldLabel,
    fieldId,
    fieldValidation,
    filledFormData,
    selectKey,
    preFilledWith,
    isPreFilled,
    fetchUrl,
  } = props;
  let preFilledVal = '';

  // TODO: logic update will require when data is needed from API in future
  useEffect(() => {
    if (isPreFilled && preFilledWith === 'filledFormData' && !fetchUrl) {
      if (filledFormData) {
        preFilledVal = filledFormData[selectKey];
      }
    }
  }, [fieldId]);

  const [data, setData] = useState(preFilledVal);

  useEffect(() => {
    setData(preFilledVal);
  }, [preFilledVal]);

  const renderElement = (
    <p className={cssProperties.style}>{parseHtml(data)}</p>
  );

  return (
    <>
      <label className={fieldLabel.cssProperties.style} htmlFor={fieldId}>
        {fieldLabel.label}
      </label>
      {fieldValidation && !fieldValidation.required && (
        <span className={fieldLabel.cssProperties.style}>{' '}(Optional)</span>
      )}
      {renderElement}
      {fieldValidation && fieldValidation.disabled && (
        <input type="hidden" id={fieldId} name={fieldId} value={data} />
      )}
    </>
  );
};

P.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  preFilledWith: PropTypes.string,
  fetchUrl: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  isPreFilled: PropTypes.string,
};

export default P;
